<template>
  <div class="modal fade contact_form_modal" id="apartmentModal" @click.self="$emit('close')">
    <div class="modal-dialog modal-dialog-centered " role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="$emit('close')">
            <svg viewBox="0 0 10 10">
              <use xlink:href="/assets/site/images/sprites.svg?ver=44#sprite-close"></use>
            </svg>
          </button>
        </div>
        <div class="modal-body">
          <h5 class="modal-title text-center">Заказать звонок</h5>
          <form  class="contact_form">
            <div>
              <input  v-model="form.phone"  class="form-control"  placeholder="Телефон" id="contact_phone"
                      type="tel" v-phone
                      :class="{'is-invalid': errors.has('phone')}">
              <div class="invalid-feedback" v-text="errors.get('phone')"></div>
            </div>
            <label class="modal__label">
              Дополнительные поля
            </label>
            <div class="mb-4">
              <input  v-model="form.name" type="text" class="form-control"  placeholder="Ваше имя" id="contact_name"
                      :class="{'is-invalid': errors.has('name')}">
              <div class="invalid-feedback" v-text="errors.get('name')"></div>

            </div>
            <div class="mb-4">
              <input name="email" type="email" v-model="form.email" class="form-control"  placeholder="Email" id="contact_email"
                     :class="{'is-invalid': errors.has('email')}">
              <div class="invalid-feedback" v-text="errors.get('email')"></div>
            </div>
            <div class="mb-4">
              <textarea class="form-control" v-model="form.comment" name="comment"  placeholder="Комментарий"  rows="4"></textarea>
              <div class="invalid-feedback"></div>
            </div>
            <div class=" mb-3 mt-2">
              <button type="submit" class="btn button-red" style="width: 40%" @click.prevent="submitForm">Отправить</button>
            </div>
            <label class="form-checkbox">
                        <span class="modal__conf-text">
                            Я согласен(-на) с <a class="landing-questions__link" href="/privacy" target="_blank">политикой
                            конфиденциальности.</a>
                        </span>
              <input name="conf_policy" v-model="form.conf_agree" type="checkbox" class="form-checkbox__input"  :class="{'is-invalid': errors.has('conf_agree')}">
              <span class="form-checkbox__checkmark"></span>  <br>
              <div class="invalid-feedback invalid-feedback--conf_agree" v-text="errors.get('conf_agree')"></div>
            </label>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    import {mask} from 'vue-the-mask'
    import { Errors } from  '@/common/services/errors.js';
    export default {
      directives: {mask},
      props: ["id", "type"],

      data() {
        return {
          form: {
            name:'',
            email:"",
            phone:"",
            comment:"",
            page_url:window.location.href,
            pageable_type:"App/Models/Cottage",
            pageable_id: this.id,
            type: this.type,
            conf_agree:true,
          },
          errors: new Errors(),
        }
      },
      methods: {

        submitForm() {
          axios.post('/contact/cottage', this.form)
              .then((response) => {
                // console.log(response.data)

                if(response.data.errors) {
                  this.errors.record(response.data.errors)
                  console.log(this.errors);
                } else {
                  this.$emit('close');
                  window.location.href = '/thanks-page';
                }
              })
              .catch((error => {
                console.log(error.response)
              }))
        }
      },
      mounted() {

      }

    }
</script>
